import listmodule from './list.js';
import { ADMINLIST_TWOFACTOR } from '../actions/adminlistactions';
const state = {
    ...listmodule.state,
    twofactor: null
};

const getters = {
    ...listmodule.getters,
    twofactor: state => state.twofactor,
};

const actions = {
    ...listmodule.actions,
    [ADMINLIST_TWOFACTOR]: ({ commit }, twofactor) => {
        console.log('twofactor' + twofactor)
        commit(ADMINLIST_TWOFACTOR, twofactor);
    },
};

const mutations = {
    ...listmodule.mutations,
    [ADMINLIST_TWOFACTOR]: (state, twofactor) => {
        state.twofactor = twofactor;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};